import { network } from "../network/network.js";
export async function fetchStore(opts) {
    const _endpoint = opts.endpoint.includes("/store")
        ? opts.endpoint
        : opts.endpoint.replace("/render", "/store");
    return await network(_endpoint, {
        admin: opts.admin,
        query: opts.variants ? { variants: opts.variants.join(",") } : undefined,
        headers: {
            "x-csrf-token": opts.csrfToken,
        },
    });
}
